export default {
  showOnlyAvailableApps: 'Show only available apps',
};
